import React from "react";
import {
    AmountType
} from "../UIHelpers";

export const AmountTypeColumnFormatter = (cellContent, row) => (
    AmountType[row.amountType]
);
